import { render, staticRenderFns } from "./reviewHeader.vue?vue&type=template&id=1732374b&scoped=true"
import script from "./reviewHeader.vue?vue&type=script&lang=js"
export * from "./reviewHeader.vue?vue&type=script&lang=js"
import style0 from "./reviewHeader.vue?vue&type=style&index=0&id=1732374b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1732374b",
  null
  
)

export default component.exports